import { render, staticRenderFns } from "./Thread.vue?vue&type=template&id=6df59cd4&scoped=true"
import script from "./Thread.vue?vue&type=script&lang=js"
export * from "./Thread.vue?vue&type=script&lang=js"
import style0 from "./Thread.vue?vue&type=style&index=0&id=6df59cd4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df59cd4",
  null
  
)

export default component.exports